export var URLUtils;
(function (URLUtils) {
    URLUtils.isLocalhost = window.location.href.indexOf('file:///') === 0 || window.location.href.indexOf('localhost') > -1 || window.location.href.indexOf('192.168') > -1;
    let _urlVars = null;
    function getUrlVars(href = window.location.search) {
        if (!_urlVars) {
            const parse = function (params, pairs) {
                const pair = pairs[0];
                const parts = pair.split('=');
                const key = decodeURIComponent(parts[0]);
                const value = decodeURIComponent(parts.slice(1).join('='));
                if (typeof params[key] === "undefined") {
                    params[key] = value;
                }
                else {
                    const arr = [];
                    params[key] = arr.concat(params[key], value);
                }
                return pairs.length == 1 ? params : parse(params, pairs.slice(1));
            };
            _urlVars = href.length == 0 ? {} : parse({}, href.substr(1).split('&'));
        }
        return _urlVars;
    }
    URLUtils.getUrlVars = getUrlVars;
    function clearUrlFromVars(add = '') {
        let index = window.location.href.indexOf('?');
        let newURL = '';
        if (index == -1) {
            index = window.location.href.indexOf('#');
        }
        if (index != -1) {
            newURL = window.location.href.substring(0, index);
        }
        window.history.pushState('page', 'Title', newURL + add);
    }
    URLUtils.clearUrlFromVars = clearUrlFromVars;
    function joinUrl(...values) {
        const parts = [];
        for (let i = 0; i < values.length; i++) {
            const p = String(values[i]).replace(/^\/+|\/+$/g, '');
            parts.push(p);
        }
        return parts.join('/');
    }
    URLUtils.joinUrl = joinUrl;
    function absUrl(url) {
        url = String(url);
        if (/^\//.test(url) || /^(?:https?:)?\/\//.test(url)) {
            return url;
        }
        return '/' + url;
    }
    URLUtils.absUrl = absUrl;
    function addParameterToURL(url, param) {
        let newUrl = url;
        newUrl += (url.split('?')[1] ? '&' : '?') + param;
        return newUrl;
    }
    URLUtils.addParameterToURL = addParameterToURL;
})(URLUtils || (URLUtils = {}));
